module["exports"] = [
  "#{Address.city} #{suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/team/name.js
// module id = 1894
// module chunks = 0